import { Mode } from '@hewey/shared'

// The list a recipe's ingredients last went to. sessionStorage, not
// localStorage: it's remembered until the tab or app is closed, then the
// picker starts from the global mode again.
const KEY = 'hewey.groceryListChoice'

export const readListChoice = (): Mode | null => {
	try {
		const parsed = Mode.safeParse(window.sessionStorage.getItem(KEY))
		return parsed.success ? parsed.data : null
	} catch {
		return null
	}
}

export const writeListChoice = (mode: Mode): void => {
	try {
		window.sessionStorage.setItem(KEY, mode)
	} catch {
		// Storage blocked: the picker falls back to the global mode.
	}
}
